import quotationRequestService from "../../../../services/procurementService/quotationRequestService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_QUOTATIONREQUESTS } from "../../../../utils/constants";
import { QuotationRequestInterface } from "../../../../models/ProcurementModule/QuotationRequest";

const useQuotationRequests = (
  purchaseOrderId: string | undefined,
  page: number,
  pageSize: number
) =>
  useQuery<QuotationRequestInterface[], Error>({
    queryKey: [CACHE_KEY_QUOTATIONREQUESTS, purchaseOrderId, page, pageSize],
    queryFn: () =>
      quotationRequestService.GetAll(purchaseOrderId, page, pageSize),
    initialData: [],
    enabled: !!purchaseOrderId,
  });

export default useQuotationRequests;
